/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('theme:loading:end', function(event) {
  /*var currentBogoUpdatedMessage = document.getElementById('fn-cartBogoMessage');
  var announcementBogoMessage = document.getElementById('fn-announcementBogoMessage');
  if (currentBogoUpdatedMessage) {
    console.log('Updated text: ', currentBogoUpdatedMessage);
  }
  if(announcementBogoMessage) {
    
  }
  
  console.log('trigger theme loading')*/
});

/* New Sections javascript to recreate carousel when changed at customize */
document.addEventListener("shopify:section:load", function(event){
  /* Listen changes to product template to recreate the style carousel */
  if (event.target.id == 'shopify-section-product-template') {
    var styledCarousel = document.querySelector('.product-styled-slideshow-wrapper .Carousel');
    if (styledCarousel) {
      var flkty = new Flickity(styledCarousel, {
        prevNextButtons: true,
        pageDots: true,
        adaptiveHeight: true
      });
    }
  }
  
  var homeSection = event.target.querySelector('section');
  if (homeSection) {
    var homeSectionType = homeSection.getAttribute('data-section-type');
    var homeSectionId = '#' + homeSection.getAttribute('id');
    if (homeSectionType && homeSectionType == 'collection-with-logos') {
      var logosCarousel = document.querySelector(homeSectionId + '.Section--Logos_Collections .Carousel');
      if (logosCarousel) {
        console.log('Logos Carousel')
        var flkty = new Flickity(logosCarousel, {
          prevNextButtons: true,
          pageDots: false,
          cellAlign: "center",
          wrapAround: false,
          percentPosition: false,
          dragThreshold: 10,
          breakpoints: [
            {
              matches: "lap-and-up",
              settings: {
                prevNextButtons: true,
                draggable: false,
                wrapAround: true,
                pageDots: true,
                groupCells: 4
              }
            }
          ]
        });
      }
    }
  }  
});